module.exports = __webpack_public_path__ + "img/banner-package.d88bb282.png";